import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostBodyInterface } from 'common/types/entities/blog-post-body-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import {
  migrateBackground,
  migrateBackgroundColor,
  migrateReadOnly,
} from '../utils/migrateUtils'

export function migrateBlogPostBody(
  entity: OldEntityInterface,
): BlogPostBodyInterface {
  const blogPostBody: BlogPostBodyInterface = {
    id: entity.id,
    type: EntityTypeEnum.BlogPostBody,
    childIds: entity.childIds || [],
    htmlAttrId: entity.options.attrId,
    background: {},
  } as BlogPostBodyInterface

  if (entity.options?.blur !== undefined) {
    blogPostBody.blur = entity.options.blur
  }

  migrateReadOnly<BlogPostBodyInterface>(blogPostBody, entity)

  if (entity.mobileStyles) {
    blogPostBody.mobileBackground = {}
  }

  migrateBackgroundColor(blogPostBody, entity)
  migrateBackground(blogPostBody, entity)

  return blogPostBody
}
